//////// GHG 3.13 EA
const threeThirteenSchema = {
  title: "3.13 Downstream Leased Assets",
  addAPI: "cat5_2AddEmissionActivityAPI",
  cat: "cat5_2",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Activity Name",
      resetOnChange: false,
      required: true,
    },
    //////// Activity Type
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Asset Name",
      optionsAPI: "cat5_2EADropdownAPI",
      required: true,
    },
  ],
};
export default threeThirteenSchema;
